import { render, staticRenderFns } from "./PostingQueueCard.vue?vue&type=template&id=579b1034&"
import script from "./PostingQueueCard.vue?vue&type=script&lang=js&"
export * from "./PostingQueueCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports